import React, { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SHIPPERS from "../../../assets/images/icons/ShippersEmpty.svg";
import Button from "../../../components/buttons/buttons";
import Table from "../../../components/tables/tableCols1";
import TableSkeleton from "../../../components/skeleton/table";
import TableFilter from "../../../components/tables/tableFilter";
import Selected from "../../../assets/images/icons/selected.svg";
import NotSelected from "../../../assets/images/icons/not_selected.svg";
import { Pagination } from "../../../components/pagination/pagination";
import {
  filterShippers,
  searchShippers,
  filterShippersNoPage,
} from "../../../redux/shippers/shippersActions";
import { writeFileWithXLSX } from "../../../components/exports/xlsx";
import { AllFiltersModal } from "../../../components/modals/allFiltersModal";
import FilterShippersDropDown from "../../../components/dropDown/filter/shippersFilter";
import shipperType from "../../../redux/shippers/shippersTypes";

export default function Verified() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let params = useParams();
  let lastMonth = new Date();
  lastMonth.setDate(lastMonth.getDate() - 30);
  const { allShippers, filtering, searching, filterNoPage } = useSelector(
    (state) => state.shipper
  );

  const [isFilterOpen, setFilterState] = useState(false);
  const [payLoad] = useState({
    management_approved: 1,
    // start_date: lastMonth,
    // end_date: new Date(),
  });
  const [data, setData] = useState([]);
  const [input, setInput] = useState({
    search: "",
  });

  useEffect(() => {
    if (params.page) {
      dispatch(filterShippers(payLoad, params.page));
      dispatch(filterShippersNoPage(payLoad));
    }
    // eslint-disable-next-line
  }, [payLoad, params]);

  function createTableData(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((shipper, index) => {
        let single = {
          num: <span className="text-base font-semibold">{index + 1}</span>,
          name: shipper?.name,
          phone: shipper?.phone,
          address: shipper?.address,
          location: shipper?.city,
          status:
            shipper?.shipper_selected === true ? (
              <span className="text-green-400 font-bold">Active</span>
            ) : (
              <span className="text-primary font-bold">Inactive</span>
            ),

          selected:
            shipper?.shipper_selected === true ? (
              <img src={Selected} alt="selected" />
            ) : (
              <img src={NotSelected} alt="non-selected" />
            ),
          verified:
            shipper?.management_approved === true ? (
              <span className="text-green-400 font-bold">Approved</span>
            ) : (
              <span className="text-primary font-bold">Unapproved</span>
            ),

          shipper: shipper,
        };

        outputArray.push({ single });
        return true;
      });
      return outputArray;
    }
  }

  useEffect(() => {
    const dataSet = createTableData(allShippers?.data);
    setData(dataSet);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allShippers]);

  function createTableNoPage(data) {
    let dataToMap = data;
    if (Array.isArray(dataToMap)) {
      let outputArray = [];
      dataToMap.map((shipper, index) => {
        let single = {
          name: shipper?.name,
          address: shipper?.address,
          location: shipper?.city,
          phone: shipper?.phone,
          selected:
            shipper?.shipper_selected === true ? "Selected" : "Not Selected",
          verified:
            shipper?.shipper_verified === true ? "Verified" : "Not Verified",
        };
        outputArray.push(single);
        return true;
      });
      return outputArray;
    }
  }

  const downloadCSV = () => {
    if (filterNoPage) {
      const newData = createTableNoPage(filterNoPage);
      writeFileWithXLSX(newData, {
        filename: "Approved Shippers.xlsx",
        download: true,
      });
    }
  };

  function goToSinglePage(params) {
    let id = params?.single?.shipper?.id;
    navigate(`/admin/shippers/${id}`);
  }
  function createShipper() {
    navigate(`/admin/create-shipper`);
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    e.preventDefault();
    setInput({ ...input, [name]: value });
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      doSearch();
    }
  };

  const showSearch = (search) => {
    let dataSet = createTableData(search);
    setData(dataSet);
  };

  const removeSearch = () => {
    if (input?.search?.length === 0) {
      let dataSet = createTableData(allShippers?.data);
      setData(dataSet);
      dispatch({
        type: shipperType["SEARCH_SHIPPERS"],
        payLoad: { data: [] },
      });
    }
  };

  async function doSearch() {
    try {
      let response = await dispatch(searchShippers(input));
      if (response?.status === "success") {
        showSearch(response?.data);
      }
      if (!response?.status) {
        showSearch([]);
      }
    } catch (error) {}
  }

  useEffect(() => {
    if (input?.search?.length === 0) {
      removeSearch();
    }
    // eslint-disable-next-line
  }, [input, dispatch]);

  const columns = useMemo(
    () => [
      {
        Header: "",
        hideHeader: false,
        id: "checkbox-table-column",
        // First group columns
        columns: [
          {
            Header: "",
            accessor: "single.selected",
          },
          {
            Header: "Name",
            accessor: "single.name",
          },

          {
            Header: "Phone Number",
            accessor: "single.phone",
          },
          {
            Header: "Address",
            accessor: "single.address",
          },
          {
            Header: "Status",
            accessor: "single.status",
          },
          {
            Header: "Approved",
            accessor: "single.verified",
          },
          {
            Header: "Location",
            accessor: "single.location",
          },
        ],
      },
    ],
    []
  );

  return (
    <div data-test="">
      <TableFilter
        title={"Shippers"}
        onChange={handleChange}
        handleKeyDown={handleKeyDown}
        payLoad={payLoad}
        page={params.page}
        filter={
          <AllFiltersModal
            isFilterOpen={isFilterOpen}
            setFilterState={setFilterState}
          >
            <FilterShippersDropDown
              isFilterOpen={isFilterOpen}
              setFilterState={setFilterState}
              payLoad={payLoad}
            />
          </AllFiltersModal>
        }
        searchPlaceholder={"Shipper Name or Phone Number"}
      >
        <Button.Primary title={"+ Create Shipper"} onClick={createShipper} />
        <Button.Secondary
          title={"Download CSV"}
          onClick={() => downloadCSV()}
          disabled={!data}
        />
      </TableFilter>

      <div className="border-b border-[#E4E4F3]"></div>

      <div className="bg-white rounded-md py-4 px-3">
        {filtering || searching ? (
          <TableSkeleton />
        ) : data?.length > 0 ? (
          <Table
            columns={columns}
            data={data?.length > 0 ? data : []}
            onClick={goToSinglePage}
            className="w-full"
            rowClass="hover:shadow-md cursor-pointer"
          />
        ) : (
          <div className="text-center">
            <div className="flex justify-center my-12 ">
              <img src={SHIPPERS} alt="shippers" />
            </div>
            <p className="font-bold text-xl my-3">Shippers</p>
            <p className="text-sm text-gray-500">
              You have no approved shippers
            </p>
          </div>
        )}
        <Pagination data={allShippers} route={"admin/shipper/unapproved"} />
      </div>
    </div>
  );
}
